import React from 'react';

import PropTypes from 'prop-types';

const CurrentTimeComponent = ({ currentTimePosition }) => (
  <div className="absolute top-[25px] left-0 bottom-0 w-0 border-r border-dashed border-[#4f90c7] z-10 pointer-events-none" style={{ transform: `translate3d(${currentTimePosition}px, 0, 0)` }} />
);

CurrentTimeComponent.propTypes = {
  currentTimePosition: PropTypes.number.isRequired,
};

export default CurrentTimeComponent;
